module.exports = __webpack_public_path__ + "img/icon-grid.d7beaf2c.svg";